import React from "react";
import { asyncWithLDProvider, LDContext } from "launchdarkly-react-client-sdk";

declare global {
  interface Window {
    Cypress?: any;
  }
}

export type AnonymousContext = { anonymous: true; key?: string };

export interface Context {
  user:
    | { key: string; name?: string; email?: string; avatar?: string }
    | AnonymousContext;
  organisation: { key: string; name?: string } | AnonymousContext;
}

export type ContextKey = keyof Context;

export const ANONYMOUS_CONTEXT: AnonymousContext = {
  anonymous: true,
  key: window.Cypress ? "cypress" : undefined,
};

export const INITIAL_CONTEXT: LDContext = {
  kind: "multi",
  user: ANONYMOUS_CONTEXT,
};

// No-op provider that just renders children when LaunchDarkly is disabled
const NoOpProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return children;
};

export async function initialiseLaunchDarkly() {
  if (!import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID) {
    console.info("LaunchDarkly disabled: No client ID provided");
    return NoOpProvider;
  }
  return asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    context: INITIAL_CONTEXT,
  });
}
